import axios from 'axios'

import { formatDate, getEndOfWorkDay, getStartOfWorkDay } from '../../@paco/helpers/date'
import { DateFormat } from '../../@paco/types/dateFormatTypes'

import { TRACK_TYPE_FINISHED, TRACK_TYPE_REVIEW } from '../../constants'
import { getLoketBridgeApiUrl } from '../index'

export function getIncludes(trackType) {
    const includes = [
        'department',
        'department.group',
        'owner.roles',
        'owner.departments',
        'owner.employmentType',
        'shift.department',
        'shift.shiftPlannings',
        'shift.shiftPlannings.user',
        'shift.shiftPlannings.user.roles',
        'shift.shiftPlannings.user.departments',
    ]

    if (trackType === TRACK_TYPE_REVIEW || trackType === TRACK_TYPE_FINISHED) {
        return [
            ...includes,
            'feedback',
            'assessor',
            'assessor.roles',
            'comments',
            'comments.owner',
        ]
    }

    return includes
}

export const getUserTracks = (userId, date) => {
    const startDate = getStartOfWorkDay(date)
    const endDate = getEndOfWorkDay(date)

    return axios.get(
        `${process.env.REACT_APP_API_URL}/tracks`,
        {
            params: {
                startDate: formatDate(startDate, DateFormat.apiDateTime),
                endDate: formatDate(endDate, DateFormat.apiDateTime),
                userUuids: JSON.stringify(userId),
            },
        },
    )
}

export const postSyncTvt = (payrollPeriod) => {
    const { id } = payrollPeriod

    return axios.put(
        `${getLoketBridgeApiUrl()}/leave/tvt/sync/${id}`,
    )
}
